import { SchemaRecord } from "../SchemaRecord.js";

export class NodeStatusParams extends SchemaRecord {
  static type = "chat.params.node_status";
  static schema = {};
}
